import { WorkoutListPage } from '../../component/workout-list-page/workout-list-page'
import { DEFAULT_WORKOUT_SORT } from '../../context/filter-context'
import { usePaginatedWorkouts } from '../../hook/use-paginated-workouts'
import { WorkoutPreset } from '../../service/core-service'
import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

const presetToTitle: Partial<Record<WorkoutPreset, string>> = {
  popular: 'Popular Workouts',
  trending_express: 'Trending Express Workouts',
  'new-workouts': 'New Workouts',
  'new-workouts-expanded': 'Workouts This Month',
}
export const WorkoutPresetScreen = (): React.ReactElement => {
  const { preset } = useParams<{ preset: WorkoutPreset }>()
  const navigate = useNavigate()

  const baseFilter = preset && presetToTitle[preset] ? { preset } : undefined
  const { workouts, totalPages, page, setPage, isLoading } = usePaginatedWorkouts(baseFilter, DEFAULT_WORKOUT_SORT)

  useEffect(() => {
    if (preset && !presetToTitle[preset]) {
      navigate(-1)
    }
  }, [preset, navigate])

  return (
    <WorkoutListPage
      title={preset ? presetToTitle[preset] : ''}
      workouts={workouts}
      isLoading={isLoading}
      page={page}
      totalPages={totalPages}
      onPageChange={setPage}
    />
  )
}
